import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import {RiListCheck3} from "react-icons/ri";
import Select from "react-select";
import "react-multi-date-picker/styles/layouts/mobile.css"


function CreateReturn() {
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = React.useState(false);


    const [selectOptions, setSelectOptions] = React.useState( null);
    const [selectedOptions, setSelectedOptions] = React.useState( null);



    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        let params = {
            count: 200,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            processFor: 'CRM',
        }
        API.getVendors(params)
            .then((response) => {

                const vendors = response.data;
                let options = [];
                for (let data in vendors) {

                    options.push({
                        value: vendors[data].id,
                        label: vendors[data].title + " - " + vendors[data].city,
                    })
                }
                setSelectOptions(options)
                setIsLoaded(true)

            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }, []);

    const onButtonClick = () => {

        if (!selectedOptions) {
            toast.error('لطفا یک نماینده انتخاب کنید')
            return false;
        }

        let request = {

            vendor_id: selectedOptions.value,

        }
        API.storeROrder(request)
            .then((response) => {
                toast.success(response.message);
                setTimeout(() => {
                    navigate('/returned-orders/' + response.data.id);
                }, 2000);


            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header/>
            <Navbar page="createreturn"/>

            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <RiListCheck3 className='ms-2' />
ثبت سفارش مرجوعی از طرف نماینده
                    </h1>
                    {/*   <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item">Pages</li>
                            <li className="breadcrumb-item active">Blank</li>
                        </ol>
                    </nav>*/}
                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body pt-4 table-responsive">
                                    <div className="row filter-box mb-5 pb-2 rounded text-small-2">

                                        <div className="col-12  mt-3">
                                            <Select
                                                options={selectOptions}
                                                placeholder="انتخاب نماینده"
                                                value={selectedOptions}

                                                isSearchable={true}
                                                onChange={

                                                    (event) => {
                                                        setSelectedOptions(event)

                                                    }
                                                }
                                            />
                                        </div>
                                        <div className="col-12  mt-5 text-start">
                                           <button className="btn btn-warning w-50 text-small-2"

                                           onClick={onButtonClick}
                                           >
                                               ثبت درخواست مرجوعی برای نماینده انتخابی
                                           </button>
                                        </div>

                                    </div>


                                </div>
                            </div>

                        </div>


                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default CreateReturn;